// extracted by mini-css-extract-plugin
export default {"title":"certificate_title__T6aIt","card-cert":"certificate_card-cert__ptORK","card-add":"certificate_card-add__HcjOB","upload-box":"certificate_upload-box__YTnOi"};